import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import H5 from '../typography/headers/H5'

const Icon = styled.div`
  background: ${props =>
      `url(${props.isActive ? props.activeIcon : props.inactiveIcon})`}
    no-repeat;
  background-size: 100%;
  cursor: pointer;
  transition: 0.2s all;
  height: ${props => props.height};
  width: ${props => props.width};
  -webkit-filter: blur(0px);

  &:hover {
    background: ${props => `url(${props.hoverIcon})`} no-repeat;
    background-size: 100%;
  }
`

const NavLabel = styled(H5)`
  display: table;
  position: absolute;
  top: 50%;
  left: ${props => (props.show ? 40 : 30)}px;
  transform: translateY(-50%);
  padding: 10px 15px;
  border-radius: 5px;
  background-color: #263746;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  color: #ffffff;
  line-height: 18px;
  opacity: ${props => (props.show ? 1 : 0)};
  transition: all 0.5s ease-out;
  pointer-events: none;
  white-space: nowrap;
`

class NavItem extends React.Component {
  constructor() {
    super()
    this.onIconClickBound = this.onIconClick.bind(this)
    this.onHoverBound = this.onHover.bind(this)
    this.onLeaveHoverBound = this.onLeaveHover.bind(this)
    this.state = {
      showLabel: false
    }
  }

  render() {
    return (
      <div style={{ position: 'relative' }}>
        <Icon
          onClick={this.onIconClickBound}
          onMouseOver={this.onHoverBound}
          onFocus={this.onHoverBound}
          onMouseLeave={this.onLeaveHoverBound}
          {...this.props}
        />
        <NavLabel show={this.state.showLabel}>{this.props.label}</NavLabel>
      </div>
    )
  }

  onIconClick() {
    this.props.handleClick()
  }

  onHover() {
    this.setState(() => ({
      showLabel: true
    }))
  }

  onLeaveHover() {
    this.setState(() => ({
      showLabel: false
    }))
  }
}

NavItem.propTypes = {
  label: PropTypes.string.isRequired,
  activeIcon: PropTypes.string.isRequired,
  inactiveIcon: PropTypes.string.isRequired,
  hoverIcon: PropTypes.string,
  isActive: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired
}

export default NavItem



// WEBPACK FOOTER //
// ./src/components/navigation/NavItem.js